<div class="loan-information-container">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #loanInfoForm="ngForm" class="loan-info-form">
    <div class="section-header mb-3">
      <h5>Loan Details</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Program Name</label>
        <text-input
          [(ngModel)]="formData.programName"
          name="programName"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Loan Purpose</label>
        <text-input
          [(ngModel)]="formData.loanPurpose"
          name="loanPurpose"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Amortization Type</label>
        <text-input
          [(ngModel)]="formData.amortizationType"
          name="amortizationType"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Note Rate</label>
        <text-input
          [ngModel]="formatPercentage(formData.noteRate)"
          name="noteRate"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4 d-flex align-items-center justify-content-between">
      <h5 class="mb-0">Buydown Information</h5>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="editBuydownToggle"
            [(ngModel)]="formData.changeBuydown"
            name="changeBuydown">
          <label class="form-check-label" for="editBuydownToggle">Edit Buydown Info</label>
          @if (formData.changeBuydown) {
            <small class="text-warning mt-1 ms-1">
              <i class="fa-solid fa-exclamation-triangle"></i>
              Pricing not impacted until loan is repriced.
            </small>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Buydown</label>
        <select-input
          name="buydown"
          [(ngModel)]="formData.buydown"
          [options]="yesNoOptions"
          [readonly]="!formData.changeBuydown"
          [required]="formData.changeBuydown">
        </select-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Buydown Type</label>
        <select-input
          name="buydownType"
          [(ngModel)]="formData.buydownType"
          [options]="buydownTypeOptions"
          [readonly]="!formData.changeBuydown"
          [required]="formData.changeBuydown">
        </select-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Buydown Contributor</label>
        <select-input
          [(ngModel)]="formData.buydownContributor"
          name="buydownContributor"
          [options]="buydownContributorOptions"
          [readonly]="!formData.changeBuydown"
          [required]="formData.changeBuydown">
        </select-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Loan Amounts</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Base Loan Amount</label>
        <currency-input
          [(ngModel)]="formData.baseLoanAmount"
          name="baseLoanAmount"
          [readonly]="true"
          [allowDecimals]="true">
        </currency-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Total Loan Amount</label>
        <currency-input
          [(ngModel)]="formData.totalLoanAmount"
          name="totalLoanAmount"
          [readonly]="true"
          [allowDecimals]="true">
        </currency-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Sales Price</label>
        <currency-input
          [(ngModel)]="formData.salesPrice"
          name="salesPrice"
          [readonly]="true"
          [allowDecimals]="true">
        </currency-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Appraised Value</label>
        <currency-input
          [(ngModel)]="formData.appraisedValue"
          name="appraisedValue"
          [readonly]="true"
          [allowDecimals]="true">
        </currency-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Ratios & Escrow</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">LTV / CLTV</label>
        <text-input
          [ngModel]="formatLtvCltv()"
          name="ltvCltv"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Impounds</label>
        <select-input
          [(ngModel)]="formData.impoundsWaived"
          [options]="yesNoOptions"
          name="impoundsWaived">
        </select-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Dates</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Close of Escrow Date</label>
        <date-input
          [(ngModel)]="formData.closeOfEscrowDate"
          name="closeOfEscrowDate"
          [required]="true">
        </date-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">First Payment Date</label>
        <date-input
          [(ngModel)]="formData.firstPaymentDate"
          name="firstPaymentDate">
        </date-input>
      </div>
    </div>
  </form>
</div>
